import Link from 'next/link';
import styles from './index.module.css';

const FreeReturnPolicy = () => {
  return (
    <div className={styles.returnPolicyContainer}>
      <span className={styles.returnPolicyIcon}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='18'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        >
          <path d='M21 3V16L12 23L3 16V3C3 3 6 1 12 1C18 1 21 3 21 3Z' />
          <path d='M7 11L10 14L17 7' />
        </svg>
      </span>
      <div className={styles.returnPolicyText}>
        <span>30 Day Free Return Policy</span>
        <Link
          href='https://sprisupport.zendesk.com/hc/en-us/articles/12171053036685-Returns-And-Cancellations/'
          target='_blank'
          rel='noopener noreferrer'
          className={styles.learnMoreLink}
        >
          Learn more
        </Link>
      </div>
    </div>
  );
};

export default FreeReturnPolicy;
